export default __webpack_public_path__ + "static/media/team-player-badge.fdf864df.svg";